import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Award, Loader2 } from "lucide-react";
import { formatTanggal } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function VerifikasiSertifikat() {
  const { kode } = useParams();
  const [state, setState] = useState({ loading: true, data: null, error: null });

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${BACKEND_URL}/api/lms/verifikasi/${kode}`);
        setState({ loading: false, data, error: null });
      } catch (e) {
        setState({ loading: false, data: null, error: e.response?.data?.detail || "Sertifikat tidak ditemukan" });
      }
    })();
  }, [kode]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-600 to-purple-700 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl p-8" data-testid="verifikasi-card">
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 text-indigo-600 font-bold">
            <Award className="w-6 h-6" /> Portal PENA
          </div>
          <div className="text-slate-500 text-sm mt-1">Verifikasi Keaslian Sertifikat</div>
        </div>

        {state.loading && (
          <div className="text-center py-10 text-slate-500"><Loader2 className="w-6 h-6 animate-spin mx-auto mb-2" />Memverifikasi…</div>
        )}

        {state.error && (
          <div className="text-center py-8" data-testid="verifikasi-invalid">
            <XCircle className="w-14 h-14 text-rose-500 mx-auto mb-3" />
            <h3 className="text-lg font-bold text-rose-700">Sertifikat Tidak Ditemukan</h3>
            <p className="text-slate-500 text-sm mt-1">{state.error}</p>
            <div className="mt-4 text-xs font-mono text-slate-400 break-all">Kode: {kode}</div>
          </div>
        )}

        {state.data && (
          <div data-testid="verifikasi-valid">
            <div className="text-center pb-5 border-b border-slate-200">
              <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto mb-2" />
              <h3 className="text-lg font-bold text-emerald-700">Sertifikat Asli & Valid</h3>
              <div className="mt-1 font-mono text-xs text-slate-500 break-all">{state.data.kode}</div>
            </div>
            <dl className="mt-5 space-y-3">
              <Row label="Nama Guru" value={state.data.nama_guru} />
              <Row label="NIY" value={state.data.niy || "—"} />
              <Row label="Judul Pelatihan" value={state.data.judul_pelatihan} />
              <Row label="Skor" value={<b>{state.data.skor} / 100</b>} />
              <Row label="Nilai Minimal" value={state.data.min_skor} />
              <Row label="Tanggal Lulus" value={formatTanggal(state.data.tanggal_lulus)} />
            </dl>
          </div>
        )}

        <div className="mt-8 pt-4 border-t border-slate-100 text-center text-xs text-slate-400">
          Verifikasi resmi oleh Portal PENA — SLB Pelita Nusa Pekanbaru
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="grid grid-cols-3 gap-3 items-baseline">
      <dt className="text-xs text-slate-500 uppercase tracking-wide">{label}</dt>
      <dd className="col-span-2 text-slate-900">{value}</dd>
    </div>
  );
}
